export default __webpack_public_path__ + "static/media/DiagonalCard.4d91222e.svg";